import { shape, string } from "prop-types";

export const configuratorViewShape = shape({
  room: string
});

export default configuratorViewShape;
